import {
  getFriendlyId as getDomainFriendlyId,
  isParentType as isDomainParentType,
} from '@risksmart-app/domain/src/types/consts';
import type { ParentType } from '@risksmart-app/domain/src/types/consts/parent-type';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';

/**
 * Web-facing adapter over the SINGLE source of truth for the friendly-id
 * format: `getFriendlyId` in `@risksmart-app/domain` (which the notification
 * payloads, rest-api and tRPC layers also use). This file no longer owns a
 * prefix map — it only narrows the GraphQL-generated `Parent_Type_Enum` onto
 * the domain `ParentType` union.
 *
 * `Parent_Type_Enum` carries a couple of values the domain union doesn't
 * (result-row types like `compliance_monitoring_assessment_result`); those
 * have no prefix and fall back to the bare sequence, exactly as before.
 */
export const getFriendlyId = (
  objectType: ParentType,
  sequentialId?: null | number
): string =>
  isDomainParentType(objectType)
    ? getDomainFriendlyId(objectType, sequentialId)
    : (sequentialId ?? '').toString();

const parentTypeValues: readonly string[] = Object.values(Parent_Type_Enum);

/**
 * Type guard for narrowing an arbitrary string (e.g. a value carried on reporting cell meta) to
 * a `Parent_Type_Enum` before passing it to {@link getFriendlyId}.
 */
export const isParentType = (value: string): value is ParentType =>
  parentTypeValues.includes(value);
